<template>
  <v-container fluid>
    <v-row no-gutters>
      <v-col offset-md="1" offset-lg="2">
        <Container :paddedTopBottom="false">
          <h2>Kelvin Ruigrok</h2>
          <p>
            Mijn naam is Kelvin Ruigrok, geboren in Pijnacker. Op jonge leeftijd
            ben ik met mijn ouders en hun agrarisch bedrijf verhuisd naar
            Noord-Brabant. Daar kwam ik voor het eerst in aanraking met
            osteopathie. De combinatie van manuele therapie en de persoonlijke
            benadering van de patiënt sprak me direct aan. Hierdoor wist ik al
            snel dat ik osteopaat wilde worden.
          </p>
          <p>
            Na het behalen van mijn VWO-diploma ben ik gestart met de
            voltijdopleiding osteopathie aan het College Sutherland in
            Amsterdam. Hier heb ik geleerd hoe het lichaam als een geheel
            functioneert en dat klachten vaak een dieperliggende oorzaak hebben.
            Mijn doel is niet alleen om symptomen te behandelen, maar om de
            daadwerkelijke oorzaak van een probleem te achterhalen en op te
            lossen.
          </p>
          <p>
            Om mijn kennis verder uit te breiden, heb ik in 2021 aanvullende
            opleidingen gevolgd, waaronder massage bij fibromyalgie en manuele
            lymfedrainage. Daarnaast heb ik een fitnesstrainercursus afgerond en
            ervaring opgedaan in de sportschool, waar ik sporters begeleidde bij
            blessureherstel.
          </p>
          <p>
            In mijn vrije tijd ben ik actief met fitness en voetbal. Ik vind het
            belangrijk om mijn eigen lichaam gezond te houden, zowel door
            beweging als door goede voeding. Mijn passie ligt in het helpen van
            mensen om pijnvrij en optimaal te kunnen functioneren.
          </p>
          <p>
            Met welke klachten kun je bij mij terecht?
          </p>
          <ul>
            <li>Rug- en nekklachten</li>
            <li>Schouderklachten</li>
            <li>RSI klachten (tenniselleboog, golferselleboog)</li>
            <li>Hoofdpijn en migraine</li>
            <li>Klachten aan de ledematen</li>
            <li>Menstruatieklachten</li>
            <li>Bekkenklachten</li>
            <li>Spier- en gewrichtsklachten</li>
            <li>Klachten na operaties</li>
            <li>Buikklachten (PDS, obstipatie, opgeblazen gevoel)</li>
            <li>Onbegrepen, vage klachten</li>
            <li>Whiplash en andere posttraumatische klachten</li>
          </ul>
          <p>
            U kunt bij mij terecht zonder verwijzing van de huisarts.
          </p>
          <img src="../../assets/team/kelvin.jpg" alt="Kelvin" />
        </Container>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Container from "../../components/Container.vue";
export default {
  name: "Kelvin",
  components: { Container }
};
</script>

<style lang="less" scoped>
h2 {
  font-size: 2rem;
  text-transform: uppercase;
  margin-bottom: 1rem;
  margin-top: 3rem;
}

h3 {
  font-size: 1.4rem;
  text-transform: uppercase;
  margin-bottom: 0.2rem;
  color: #747769;
  em {
    font-style: normal;
    color: #747769;
  }
}

img {
  max-width: 100%;
}
</style>
